import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'

import type { Projectbetrokkene } from '@models/Projectbetrokkene'

import { StyledError } from '../../../theme/components/StyledError'
import { useDeleteProjectbetrokkene } from '../../hooks/useDeleteProjectbetrokkene'

export { DeleteBetrokkene }

type Props = {
  projectbetrokkene: Projectbetrokkene
  onClose: () => void
}

/** De api bepaalt of de betrokkene ook echt verwijderd mag worden */
const DeleteBetrokkene = ({ projectbetrokkene, onClose }: Props) => {
  const { mutate: deleteProjectbetrokkene, error } =
    useDeleteProjectbetrokkene()

  const handleSubmit = () => {
    deleteProjectbetrokkene({ projectbetrokkene }, { onSuccess: onClose })
  }

  return (
    <Dialog open maxWidth="md" fullWidth>
      <DialogTitle>Betrokkene verwijderen</DialogTitle>

      <DialogContent>
        <StyledError error={error} />

        <DialogContentText>
          {`Weet u zeker dat u ${projectbetrokkene.organisatie} wilt verwijderen uit ${projectbetrokkene.gebiedscodeLabel} van ${projectbetrokkene.verantwoordelijke}? Dit kunt u niet terugdraaien.`}
        </DialogContentText>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} autoFocus>
          Nee
        </Button>

        <Button onClick={handleSubmit}>Ja</Button>
      </DialogActions>
    </Dialog>
  )
}
